import React, { useEffect, useState } from 'react';
import { ConfirmationModal } from '../modals/ConfirmationModal';
import { gaDesignerComplete } from '../../Utils/googleAnalytics';
import { isMobile, isTablet } from 'react-device-detect';

const ReviewOrder = ({
	sampleData,
	commonJSONText,
	getRoPayload,
	checkBoxValue,
	stoleType,
	stolePreview,
	colorList,
	addToCart,
	fontList,
	getFontList,
	substemNameBranding, 
	brandingTab, 
	selectedStage,
	currentStep,
	estimatedPrice,
	stoleMeta
}) => {
	const [stoleResponse, setStoleResponse] = useState([]);
	const [reviewOrderText, setReviewOrderText] = useState([]);
	const [checked, setChecked] = useState(false);
	const [confirmationModal, setConfirmationModal] = useState(false);
	const [threadColorName, setThreadColorName] = useState('');
	const [baseColorName, setBaseColorName] = useState('');
	const [showTooltip, setShowTooltip] = useState(false);

	useEffect(() => {
		setStoleResponse(sampleData);
		if (!(isMobile && !isTablet)) {
			stolePreview();
		}
		let threadColorId =
			sampleData &&
			sampleData.designSettings &&
			sampleData.designSettings.data &&
			sampleData.designSettings.data.threadColorId;
		if (threadColorId) {
			let color =
				colorList && colorList.find((col) => col.colorId === threadColorId);
			setThreadColorName((color && color.consumerColorName) || '');
		}
		let baseColorId =
			sampleData &&
			sampleData.designSettings &&
			sampleData.designSettings.data &&
			sampleData.designSettings.data.baseColorId;
		if (baseColorId) {
			let color =
				colorList && colorList.find((col) => col.colorId === baseColorId);
			setBaseColorName((color && color.consumerColorName) || '');
		}
	}, [sampleData]);

	useEffect(() => {
		setReviewOrderText(commonJSONText);
	}, [commonJSONText]);

	useEffect(() => {
		checkBoxValue(checked);
		checked?setShowTooltip(false):setShowTooltip(true);
	}, [checked, checkBoxValue]);

	useEffect(() => {
		setTimeout(() => {
			if (!window.jostensGaTracking) {    // triggered only for legacy GA code
				gaDesignerComplete(currentStep, sampleData, substemNameBranding, brandingTab, selectedStage, estimatedPrice, stoleMeta);
			}
		}, 1000);
	}, []);

	 const getFontName = (fontName)=>{
		if (fontList && fontList.length) {
			if (fontName) {
				let selectedFont =
				fontList && fontList.find((font) => font.pulseFont === fontName);
				return (selectedFont && selectedFont.consumerFontName) || '';
			}
		} else {
			getFontList();
		}
	}

	const navigateTo = (zoneCode) => {
		switch (zoneCode) {
			case 'stole-design':
				getRoPayload(stoleResponse.payload, zoneCode);
				break;
			case 'school-branding':
				getRoPayload(stoleResponse, zoneCode);
				break;
			default:
				getRoPayload(stoleResponse, `your-stole-${zoneCode}`);
				break;
		}
	};

	return (
		<>
			<div
				style={{ textAlign: 'left', overflowY: 'auto' }}
				className='container review-page'>
				<div className='review-order-row'>
					<div className='row mx-0'>
						<div className='review-order-left'>
							<p className='StoleType'>
								{reviewOrderText.stepper &&
									reviewOrderText.stepper.step1 &&
									reviewOrderText.stepper.step1.toUpperCase()}
							</p>
						</div>
						<div className='review-order-right'>
							<div className='select_icon customSelectIcon'>
								<i className='customTick tick'></i>
							</div>
						</div>
					</div>
					<div className='row mx-0'>
						<div className='review-order-left'>
							<span className='StoleDesc'>
								{stoleType} ($
								{stoleResponse &&
									stoleResponse.product &&
									stoleResponse.product.basePrice &&
									stoleResponse.product.basePrice.toFixed(2)}
								)
							</span>
						</div>
						<div className='review-order-right'>
							<span
								onClick={() => setConfirmationModal(true)}
								className='stole-edit'>
								{reviewOrderText.reviewContainer &&
									reviewOrderText.reviewContainer.edit}
							</span>
						</div>
					</div>
				</div>
				<div className='review-order-row'>
					<div className='row mx-0'>
						<div className='review-order-left'>
							<p className='StoleType'>
								{reviewOrderText.stepper &&
									reviewOrderText.stepper.step2 &&
									reviewOrderText.stepper.step2.toUpperCase()}
							</p>
						</div>
						<div className='review-order-right'>
							<div className='select_icon customSelectIcon'>
								<i className='customTick tick'></i>
							</div>
						</div>
					</div>
					<div className='row mx-0'>
						<div className='review-order-left StoleDesc'>
							{stoleResponse && (
								<span>
									{reviewOrderText.reviewContainer &&
										reviewOrderText.reviewContainer.design}
									:{' '}
									{reviewOrderText.reviewContainer &&
										reviewOrderText.reviewContainer.color}
									:{' '}
									{baseColorName}
									,{' '}
									{reviewOrderText.reviewContainer &&
										reviewOrderText.reviewContainer.tip}
									:{' '}
									{stoleResponse &&
										stoleResponse.designSettings &&
										stoleResponse.designSettings.data.tipMaterialName}
									($
									{stoleResponse &&
										stoleResponse.designSettings &&
										stoleResponse.designSettings.data.upchargeAmt &&
										stoleResponse.designSettings.data.upchargeAmt.toFixed(2)}
									),{' '}
									{reviewOrderText.reviewContainer &&
										reviewOrderText.reviewContainer.font}
									:{' '}
									{getFontName(stoleResponse &&
										stoleResponse.designSettings &&
										stoleResponse.designSettings.data.pulseFont)}
									,{' '}
									{reviewOrderText.reviewContainer &&
										reviewOrderText.reviewContainer.thread}
									: {threadColorName}
								</span>
							)}
						</div>
						<div className='review-order-right'>
							<span
								onClick={() => navigateTo('school-branding')}
								className='stole-edit'>
								{reviewOrderText.reviewContainer &&
									reviewOrderText.reviewContainer.edit}
							</span>
						</div>
					</div>
				</div>
				<div className='review-order-row'>
					<div className='row mx-0'>
						<div className='review-order-left'>
							<p className='StoleType'>
								{reviewOrderText.stepper &&
									reviewOrderText.stepper.step3 &&
									reviewOrderText.stepper.step3.toUpperCase()}
							</p>
						</div>
						<div className='review-order-right'>
							<div className='select_icon customSelectIcon'>
								<i className='customTick tick'></i>
							</div>
						</div>
					</div>
					<div className='row mx-0'>
						{stoleResponse && (
							<>
								{stoleResponse &&
									stoleResponse.zones &&
									stoleResponse.zones.map((item, index) => {
										let data;
										let decorType;
										let upchargeAmt;
										let font;
										if (
											item.data.decorType === 'text-v' ||
											item.data.decorType === 'text-h'
										) {
											data =
												item.data.textLines &&
												item.data.textLines.filter((text) => text);
											data = data && data.join(', ');
											if (item.data.decorType === 'text-v') {
												decorType = 'Text, Orientation : Vertical';
											}
											if (item.data.decorType === 'text-h') {
												decorType = 'Text';
											}
											font = getFontName(item.data.pulseFont);
										}
										if (
											item.data.decorType === 'graphic' ||
											item.data.decorType === 'graphics'
										) {
											data = item.data.assetName;
											if (item.data.groupCode === 'school-marks') {
												decorType = 'School Asset';
											} else {
												decorType = item.data.decorType;
											}
										}
										if (item.data.upchargeAmt !== 0 && item.data.upchargeAmt) {
											upchargeAmt = ` (+$${
												item.data.upchargeAmt &&
												item.data.upchargeAmt.toFixed(2)
											})`;
										} else {
											upchargeAmt = '';
										}

										return (
											<>
												<div
													className='review-order-left StoleDesc'
													key={index}>
													{decorType !== undefined &&
														`${item.zoneName} : ${decorType} : ${data || ''}${
															upchargeAmt || ''
														}${
															(font &&
																font !== undefined &&
																`, ${
																	reviewOrderText.reviewContainer &&
																	reviewOrderText.reviewContainer.font
																} : ${font}`) ||
															''
														}`}
												</div>
												{decorType !== undefined && (
													<>
														<div className='review-order-right'>
															<span
																onClick={() => navigateTo(item.zoneCode)}
																className='stole-edit'>
																{reviewOrderText.reviewContainer &&
																	reviewOrderText.reviewContainer.edit}
															</span>
														</div>
													</>
												)}
											</>
										);
									})}
							</>
						)}
					</div>
				</div>
				<div className='review-order-row'>
					<div className='row checkbox-desc'>
						<div className='custom-control custom-checkbox'>
							{showTooltip && <div className="review-pointer-tooltip">
								<i className="fa fa-exclamation-circle" aria-hidden="true" style={{marginRight:'5px'}}></i>
								Select Required Field
							</div>}
							<input
								type='checkbox'
								className='form-check-input'
								id='customCheck1'
								onChange={() => setChecked(!checked)}
							/>
							<label className='custom-control-label' htmlFor='customCheck1'>
								{reviewOrderText.reviewContainer &&
									reviewOrderText.reviewContainer.concentText}
							</label>
						</div>
						{isMobile && (
							<div className='row add-to-cart'>
								<button
									id='rightButton'
									type='button'
									class='btn btn-black'
									onClick={() => addToCart()}>
									Add to cart
								</button>
							</div>
						)}
					</div>
				</div>
			</div>

			<ConfirmationModal
				show={confirmationModal}
				onHide={() => setConfirmationModal(false)}
				commonJSONText={reviewOrderText}
				navigateTo={navigateTo}
			/>
		</>
	);
};

export default React.memo(ReviewOrder);
